import { useTranslation } from 'react-i18next';
import type { IFinancePayments } from '@interfaces/IFinance';
import { fmtUsd } from '../format';
import { APP_DEFAULT_TZ, formatLongDate } from '@utils/dateUtils';
import { KpiCard } from './KpiCard';
import { StatusPill } from './StatusPill';
import styles from './PaymentsTab.module.css';

interface IPaymentsTabProps {
  payments: IFinancePayments;
}

export function PaymentsTab({ payments }: IPaymentsTabProps) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === 'ja' ? 'ja' : 'en';

  return (
    <>
      <div className={styles.kpiRow}>
        <KpiCard
          value={`$${payments.kpis.pendingApprovalUsdK}K`}
          label={t('finance.payments.pendingApproval')}
          valueTone="amber"
        />
        <KpiCard
          value={`$${payments.kpis.approvedReadyUsdK}K`}
          label={t('finance.payments.approvedReady')}
          valueTone="blue"
        />
        <KpiCard
          value={`$${payments.kpis.paidThisMonthUsdK}K`}
          label={t('finance.payments.paidThisMonth')}
          valueTone="green"
        />
      </div>

      <section className={styles.panel}>
        <h2 className={styles.panelTitle}>{t('finance.payments.scheduleTitle')}</h2>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>{t('finance.payments.colPaymentId')}</th>
              <th>{t('finance.payments.colContractor')}</th>
              <th>{t('finance.payments.colInvoice')}</th>
              <th>{t('finance.payments.colAmount')}</th>
              <th>{t('finance.payments.colMilestone')}</th>
              <th>{t('finance.payments.colDueDate')}</th>
              <th className={styles.alignCenter}>{t('finance.payments.colStatus')}</th>
            </tr>
          </thead>
          <tbody>
            {payments.schedule.map((row) => (
              <tr key={row.id}>
                <td className={styles.mono}>{row.id}</td>
                <td>{row.contractor}</td>
                <td className={styles.mono}>{row.invoiceId}</td>
                <td className={styles.bold}>{fmtUsd(row.amountUsd)}</td>
                <td className={styles.muted}>{row.milestone}</td>
                <td className={styles.muted}>{formatLongDate(row.dueDate, lang, APP_DEFAULT_TZ)}</td>
                <td className={styles.alignCenter}>
                  <StatusPill status={row.status} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </>
  );
}
